import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class UserJoinRoleAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "UserJoinRole";

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/list";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  insertBatch(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/batch-insert";

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * @override: Lấy dữ liệu danh sách
   * @author nnlam - 05.05.2021
   */
  getRoleByUserID(userID, type) {
    // URL mặc định
    let request = {
      url: [this.getAPIUrl(), "get-role-by-user-id", userID, type].join("/"),
    };
    return httpClient.getAsync(request);
  }
}

export default new UserJoinRoleAPI();
